var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right"},[_c('span',{attrs:{"id":"totalText"}},[_vm._v(" Commission Total: "),(_vm.total < 0)?_c('span',[_vm._v("-")]):_vm._e(),_vm._v("$"+_vm._s(_vm.total ? Math.abs(_vm.total).toFixed(2) : '0.00')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }